/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:4803069b-2918-4439-8404-cbfa9cce0517",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_KA91HaqjO",
    "aws_user_pools_web_client_id": "1qsject0o3ftio3aestp1npdge",
    "oauth": {
        "domain": "automatic-get-cleared-two-prod-445816555656.auth.us-east-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 12,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "automatic-ingress-bucket-prod-445816555656",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_content_delivery_bucket": "frontend-20260402125412-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d3mierf2ggr9i2.cloudfront.net"
};


export default awsmobile;
